"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AskBrainFunction = void 0;
const FunctionBase_1 = require("../../storyV2/function/FunctionBase");
const FunctionUtil_1 = require("../../storyV2/function/FunctionUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class AskBrainFunction extends FunctionBase_1.FunctionBase {
    async run(input, identityInfo) {
        // const streamResponse = new RunStreamResponse<any>();
        const streamResponse = await this.socketRestClient.requestStream(topic => {
            return this.brainClient.openAi.askBrain(input, (0, is_blank_1.default)(topic) ? undefined : topic, FunctionUtil_1.FunctionUtil.createAbortUuid(identityInfo));
        }, "ask_brain", FunctionBase_1.FuncDataSourceType.ASK_BRAIN, identityInfo);
        return new FunctionBase_1.FuncResponse(FunctionBase_1.FuncResponseType.ASK_BRAIN, streamResponse);
    }
}
exports.AskBrainFunction = AskBrainFunction;
